import type {
  ISettingsParam,
  IStyleParam,
  SettingsParamType,
  StyleParamType,
} from '@wix/tpa-settings';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { SPECS } from '../../../consts';

export const useExperimentalCascadingSettings = () => {
  const settings = useSettings();
  const styles = useStyles();
  const { experiments } = useExperiments();

  const isMigratedEditor3StylesParamsEnabled = experiments.enabled(
    SPECS.UseMigratedEditor3StylesParams,
  );

  return {
    get: <T extends SettingsParamType, U extends StyleParamType>(
      settingsParam: ISettingsParam<T>,
      styleParam: IStyleParam<U>,
    ) => {
      const valueInSettings = settings.get(settingsParam);
      const valueInStyles = styles.get(styleParam);

      return isMigratedEditor3StylesParamsEnabled
        ? valueInStyles ?? valueInSettings
        : valueInSettings;
    },
  };
};
